(function (scope, wakeup) {
    //唤醒脚本初始化埋点
    if (!/AliApp\(TB\/|AliApp\(TB-PD\//.test(navigator.userAgent)) {
        var img = new Image(), id = "_live_" + Math.random();
        scope[id] = img;
        img.src = 'https://wgo.mmstat.com/wkp.init.i0';
    }
    if (!scope.wakeup) { scope.wakeup = wakeup(); }//这一行会在打包时修改成不同版本，修改时请谨慎
})(window, function () {
    var win = window, doc = document, M = Math, ud = void 0;
    if (typeof Object.assign != 'function') {
        Object.assign = function (target) {
            'use strict';
            if (target == null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }
            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source != null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }
            return target;
        };
    }
    var h5_uid = doc.cookie.match(/(?:^|\s)cna=([^;]+)(?:;|$)/),
        DO_NOT_ENCODE = ['ali_trackid'],//对哪些参数不使用encodeURIComponent
        load_chain = [],
        try_log = {};

    if (h5_uid) {
        h5_uid = h5_uid[1];
    } else {
        h5_uid = M.random().toString().slice(2) + M.random().toString().slice(2);
    }

    var queryString = {}, _qs, _ps;
    try {
        _qs = location.search.slice(1).split('&');
        for (var i = 0; i < _qs.length; i++) {
            _ps = _qs[i].split('=');
            queryString[_ps[0]] = _ps[1];
        }
    } catch (e) { }

    function encode(str) {
        try {
            return encodeURIComponent(str + '');
        } catch (e) {
            return 'err'
        }
    };

    // 匹配 pid 的下划线和数字部分
    var trypid = (queryString['pid'] || queryString['refpid'] || '').match(/_\d+_\d+_\d+/ig);
    // url上的pid可能是tt开头
    var pid = 'mm_0_0_0';
    if (trypid) {
        pid = 'mm' + trypid[0];
    }

    //抄底百川信息，当没有配置时用
    var backupConfig = {
        "appkey": "24570756",
        "visa": "f9a9733e34b4e74f",
        "bc_fl_src": "alimm_0"
    }

    // url上的参数和抄底百川信息
    var _qsConfig = {
        "appkey": queryString['wp_ak'] || queryString['appkey'] || '',
        "packageName": queryString['wp_pn'] || queryString['packageName'] || '',
        "backURL": queryString['wp_bc'] || queryString['backURL'] || '',
        "visa": queryString['wp_vi'] || queryString['visa'] || '',
        "bc_fl_src": queryString['bc_fl_src'] || ''
    }, queryStringConfig = {}

    for (var _key in _qsConfig) {
        if (Object.prototype.hasOwnProperty.call(_qsConfig, _key) && _qsConfig[_key] !== '') {
            queryStringConfig[_key] = _qsConfig[_key];
        }
    }


    function url2obj(url) {
        var re = {},
            unUrl,
            params;

        if (url.length && url.substr(0, 5) !== 'data:') {
            //将query前后分开
            unUrl = url.split('?');

            //无query或?有多个
            if (unUrl.length == 1) {
                unUrl = url.split('#');
                if (unUrl.length >= 2) {
                    unUrl = [unUrl[0], '#' + unUrl.slice(1).join('#')];
                } else {
                    unUrl = [unUrl[0], ''];
                }
            } else if (unUrl.length > 2) {
                unUrl = [unUrl[0], unUrl.slice(1).join('?')];
            }

            //尝试处理protocol
            unUrl[0] = unUrl[0].split('//');
            if (unUrl[0].length !== 2) {
                //与预期不符的统一处理
                unUrl[0] = [undefined, unUrl[0].join('//')];
            }

            if (unUrl[0][0] !== undefined) {
                re.protocol = unUrl[0][0];
            }
            re.path = unUrl[0][1];

            //取query部分
            //先把hash处理掉
            params = unUrl[1].split('#');
            if (params.length >= 2) {
                re.hash = params.slice(-1)[0];
                params = params.slice(0, -1).join('#');
            } else {
                params = params[0];
            }

            //将query分成键值对
            if (params) {
                re.params = {};
                params = params.split('&');
                for (var i = 0, maxi = params.length; i < maxi; i++) {
                    params[i] = params[i].split('=');
                    if (params[i][1] !== undefined) {
                        params[i][1] = params[i].slice(1).join('=');
                        try {
                            params[i][1] = decodeURIComponent(params[i][1]);
                        } catch (e) {
                        }
                    }
                    re.params[params[i][0]] = params[i][1];
                }
            }
        }

        return re;
    }

    function obj2url(obj) {
        var re = [],
            query = [],
            query_added = false;

        if (obj.protocol !== undefined) {
            re.push(obj.protocol + '//');
        }
        if (obj.path !== undefined) {
            obj.path && re.push(obj.path);
        }

        if (obj.params !== undefined) {
            for (var key in obj.params) {
                if (!query_added) {
                    re.push('?');
                    query_added = true;
                }
                if (obj.params.hasOwnProperty(key)) {
                    if (obj.params[key] !== undefined) {
                        if (DO_NOT_ENCODE.indexOf(key) !== -1) {
                            query.push([key, '=', obj.params[key]].join(''));
                        } else {
                            query.push([key, '=', encodeURIComponent(obj.params[key])].join(''));
                        }
                    } else {
                        query.push(key);
                    }
                }
            }
            re.push(query.join('&'));
        }

        obj.hash && re.push('#' + obj.hash);

        return re.join('');
    }

    function alreadyTbopen(target) {
        return target && target.params && target.params.h5Url !== undefined && /tbopen/i.test(target.path);
    }

    function appendParams(target, toAdd, notPass) {
        var points = ['ali_trackid', 'refpid', 'pid'],
            currentUrl = url2obj(location.href),
            params = {},
            addParamsToH5Url = false,
            theUrl;

        if (target.params === undefined) {
            target.params = {};
        }

        if (alreadyTbopen(target)) {
            addParamsToH5Url = true;
        }

        if (addParamsToH5Url) {
            //将参数透传给h5Url
            theUrl = target.params.h5Url;
            theUrl = url2obj(theUrl);
            if (theUrl.params === undefined) {
                theUrl.params = {};
            }
        } else {
            theUrl = target;
        }

        //添加point参数
        params.from = 'h5';

        if (currentUrl.params && (notPass !== false)) {
            //透传参数
            for (var key in currentUrl.params) {
                if (!theUrl.params.hasOwnProperty(key)) {
                    theUrl.params[key] = currentUrl.params[key];
                }
                if (points.indexOf(key) !== -1) {
                    params[key] = currentUrl.params[key];
                }
            }
        }

        if (toAdd) {
            for (var key in toAdd) {
                theUrl.params[key] = toAdd[key];
            }
        }

        if (h5_uid) {
            params.h5_uid = h5_uid;
        }

        delete currentUrl.params;
        delete currentUrl.hash;
        params.url = obj2url(currentUrl);

        theUrl.params.point = JSON.stringify(params);

        if (addParamsToH5Url) {
            target.params.h5Url = obj2url(theUrl);
        }

        return params.url;
    }

    function useAnchorLink(url, pending) {
        try_log.by = 'a';
        try_log.to_url = url;

        var a = doc.createElement('a'),
            e = new MouseEvent('click');

        a.setAttribute('href', url);
        a.style.display = 'none';

        function add() {
            doc.body.appendChild(a);
            a.dispatchEvent(e);
        }

        doWhenLoad(add, pending);
    }

    function useLocation(url) {
        try_log.by = 'location';
        try_log.to_url = url;

        goldsend(try_log, function () {
            location.href = url;
        });
    }

    function callInIframe(url, pending) {
        try_log.by = 'iframe';
        try_log.to_url = url;

        var iframe = doc.createElement('iframe');

        iframe.id = 'callapp_iframe_' + Date.now();
        iframe.frameborder = '0';
        iframe.style.cssText = 'display:none;border:0;width:0;height:0;';

        function add() {
            doc.body.appendChild(iframe);
            iframe.src = url;
        }

        doWhenLoad(add, pending);
    }

    function doWhenLoad(add, pending) {
        if (doc.readyState == "complete" || doc.readyState == "loaded") {
            goldsend(try_log, function () {
                add();
            });
        } else {
            if (pending !== undefined) {
                load_chain.push(add);
            } else {
                win.addEventListener("load", function () {
                    goldsend(try_log, function () {
                        add();
                    });
                });
            }
        }
    }

    function goldsend(data, callback) {
        var img = new Image(),
            id = "_live_" + M.random(),
            target = url2obj('https://wgo.mmstat.com/wkp.try.d'),
            spm_ab;

        win[id] = img;

        img.onload = img.onerror = function () {
            win[id] = null;
            callback && callback();
        };

        try {
            spm_ab = win['goldlog'].spm_ab.join('.');
        } catch (e) {
            spm_ab = '0.0';
        }

        target.params = {
            'cache': M.floor(M.random() * 268435456).toString(16),
            'gmkey': 'EXP',
            'gokey': JSON.stringify(data),
            'cna': '',
            'spm-cnt': spm_ab + '.0.0',
            'isbeta': 9,
            'logtype': 2
        };

        img.src = obj2url(target);

        img = null;
    }

    function wrapByBC(url, scheme, toAdd) {
        var tbopen = (scheme || 'tbopen:') + '//m.taobao.com/tbopen/index.html?action=ali.open.nav&module=h5&bootImage=0&source=alimama&h5Url=',
            others = '';

        if (toAdd) {
            for (var key in toAdd) {
                others += '&' + key + '=' + encodeURIComponent(toAdd[key]);
            }
        }

        return tbopen + encodeURIComponent(url) + others;
    }

    function tbopenEncode(obj, scheme, config) {
        try_log.to = scheme;

        if (alreadyTbopen(obj)) {
            obj.protocol = scheme;

            if (config) {
                for (var key in config) {
                    obj.params[key] = config[key];
                }
            }
            return obj2url(obj);
        } else {
            return wrapByBC(obj2url(obj), scheme, config);
        }
    }

    function normalEncode(obj, scheme) {
        var re;

        obj.protocol = scheme;

        try_log.to = scheme;

        if (scheme == 'taobao:') {
            if (alreadyTbopen(obj)) {
                re = obj2url(obj);
            } else {
                obj.protocol = 'http:';
                re = wrapByBC(obj2url(obj), scheme);
                obj.protocol = scheme;
            }
        } else {
            re = obj2url(obj);
        }
        return re;
    }

    function intentEncode(obj, scheme, pkg_name, config) {
        var re;

        function setForIntent(the_obj) {
            the_obj.protocol = 'intent:';
            the_obj.hash = 'Intent;scheme=' + scheme.replace(':', '') + ';package=' + pkg_name + ';end';
            try_log.to = 'intent:';
            return the_obj;
        }

        if (scheme == 'tbopen:' || scheme == 'taobao:') {
            re = obj2url(
                setForIntent(
                    url2obj(
                        wrapByBC(
                            obj2url(obj),
                            'http:',
                            config.tbopen_config
                        )
                    )
                )
            );
        } else {
            re = obj2url(
                setForIntent(obj)
            );
        }
        return re;
    }

    function versionAbove(str, base) {
        var a, b;

        str = str.split('.');
        base = base.split('.');

        for (var i = 0, maxi = M.max(str.length, base.length); i < maxi; i++) {
            a = parseInt(str[i] || 0);
            b = parseInt(base[i] || 0);
            if (a > b) {
                return true;
            } else if (a < b) {
                return false;
            }
        }

        return true;
    }

    //获取百川配置
    function getBcConfig(options, callback) {
        var autoConfig = ud;
        var mm_wakeup = win.mm_wakeup;
        if (mm_wakeup && Object.prototype.toString.call(mm_wakeup) === '[object Array]') {
            autoConfig = mm_wakeup.pop();
        }

        //从CDN上拉取pid与appkey的对应
        win.mm_wakeup = {
            push: function (data) {
                if (!(data.code == "404")) {
                    autoConfig = data;
                }
                var ac_config = Object.assign({}, backupConfig, autoConfig, bc_config);

                callback(ac_config);
            }
        }

        var tbopen_config = options.tbopen_config || {};

        //参数在当前页面马上能取到的，代码里配置的tbopen_config优先
        var bc_config = Object.assign({}, queryStringConfig, tbopen_config);

        //hack
        var lh = location.href;
        var adzoneid = "0";
        try {
            adzoneid = pid.match(/_(\d+)$/)[1];
        } catch (e) { }
        var isK2 = lh.indexOf('mo.m.taobao.com/bus') > 0 || lh.indexOf('mo.m.taobao.com/k2') > 0;
        var isRD = lh.indexOf('mo.m.taobao.com/wakeup') > 0; //中间页唤醒
        if (isK2 && !bc_config.bc_fl_src) {
            bc_config.bc_fl_src = 'tanx_k2_' + adzoneid + '_h5'
        }

        //没有本地参数，从OSS上拉
        if (!bc_config.appkey && !isK2 && !isRD) {
            // 自动获取百川参数
            var s = doc.createElement("script");
            // 逻辑goto 到 win.mm_wakeup = { push。。。
            s.src = '//mmwakeup.alicdn.com/' + pid.replace(/_/ig, '/') + '.js';
            var h = doc.getElementsByTagName("head")[0];
            if (h) h.insertBefore(s, h.firstChild);
        } else {
            var locConfig = Object.assign({}, backupConfig, bc_config);
            callback(locConfig);
        }

    }
    function _wakeup(url, options) {
        var defaultScheme = 'tbopen:',
            target = url2obj(url),
            current_path,
            ua = navigator.userAgent,
            isiOS = /iPhone|iPad|iPod/i.test(ua),
            isBC = ua.match(/AliApp\(BC\/([\d\.]+)/i),
            iOS9SafariFix,
            iOSYouKuFix,
            iOSQQBrowserFix,
            AndroidYouKuFix,
            AndroidBCFix,
            AndroidSamsungBrowserFix,
            AndroidOppoBrowserFix,
            AndroidUCBrowserFix,
            iOS_version;

        if (/Trident/i.test(ua)) {
            //IE下发起唤醒链接会导致页面报错，所以直接返回
            return;
        }
        // options.scheme = options.scheme || 'tbopen:';

        current_path = appendParams(target, options.params, options.pass);

        try_log = {
            h5_uid: h5_uid || '',
            url: current_path || '',
            ua: navigator.userAgent,
            v: '0.2.25'
        };

        if (isiOS) {
            if (/youku/i.test(ua)) {
                iOSYouKuFix = true;
            } else if (/MQQBrowser/i.test(ua)) {
                iOSQQBrowserFix = true;
            } else if (/Safari/i.test(ua)) {
                //iOS >= 9.0且是Safari，需要用a标签
                iOS_version = ua.match(/Version\/([\d\.]+)/i);
                if (iOS_version && iOS_version.length == 2) {
                    iOS_version = +iOS_version[1];
                    if (iOS_version >= 9) {
                        iOS9SafariFix = true;
                    }
                }
            }
        } else {
            //一些特殊情况
            if (isBC && isBC.length == 2 && versionAbove(isBC[1], '1.9.0')) {
                //安卓百川需要用tbopen
                AndroidBCFix = true;
            } else if (/SamsungBrowser/i.test(ua)) {
                //三星原生浏览器需要用intent
                AndroidSamsungBrowserFix = true;
                //忽略三星，纠正过来试试。勇智 2018年07月19日
                // AndroidSamsungBrowserFix = false;
            } else if (/OppoBrowser/i.test(ua)) {
                AndroidOppoBrowserFix = true;
            } else if (/youku/i.test(ua)) {
                AndroidYouKuFix = true;
            }
            /*else if (/UCBrowser/i.test(ua)) {
                AndroidUCBrowserFix = true;
            }*/
        }
        
        if (options.scheme === 'tbopen') {//修复一些业务中未正确传值
            options.scheme += ':';
            // console.warn("在调用wakeup时，如果要指定scheme，需要包含冒号，如scheme: 'tbopen:'");
        } else if (options.scheme === undefined) {
            options.scheme = defaultScheme;
        }

        function encodeUrl(obj, forceTbopenForTaobao) {
            if (options.scheme === defaultScheme || options.scheme === 'tbopen:' || options.scheme === 'taobao:') {
                return tbopenEncode(obj, forceTbopenForTaobao ? 'tbopen:' : options.scheme, options.tbopen_config);
            } else {
                return normalEncode(obj, options.scheme);
            }
        }

        if (AndroidSamsungBrowserFix) {
            target = intentEncode(target, options.scheme, "com.eg.android.AlipayGphone", options);
            useLocation(target);
        } else {
            if (iOS9SafariFix) {
                //iOS9以上的Safari里，使用iframe打开url scheme没有任何反应
                useAnchorLink(encodeUrl(target), options.toload);
            } else if (iOSYouKuFix || iOSQQBrowserFix) {
                useAnchorLink(encodeUrl(target, true), options.toload);
            } else if (AndroidBCFix || AndroidOppoBrowserFix || AndroidYouKuFix || AndroidUCBrowserFix) {
                callInIframe(encodeUrl(target, true), options.toload);
            } else {
                //在如网易的webview里，iframe的生成需要等待DOM的load事件。其表现和Safari中的非常类似，怀疑是WebKitWebView。
                callInIframe(encodeUrl(target), options.toload);
            }
        }

        target = null;
        options = null;
    }

    //这里要加回调
    function wakeup(url, options) {
        options = options || {};
        //只有唤醒手淘需要pid对应appkey
        if (options.scheme != void 0 && !/^(taobao)|(tbopen)/ig.test(options.scheme)) {
            _wakeup(url, options);
            return;
        }
        getBcConfig(options, function (config) {
            options.tbopen_config = config;
            _wakeup(url, options);
        })

    }
    wakeup.loaded = function () {
        while (load_chain.length) {
            try {
                goldsend(try_log, function () {
                    load_chain.shift()();
                });
            } catch (e) { }
        }
    };

    return wakeup;
});


// WEBPACK FOOTER //
// ./src/wakeup/sdk.js